export const SUPPORTED_EXTENSIONS = {
    BEX: ".bex",
    BIN: ".bin",
    CFG: ".cfg",
    CSV: ".csv",
    ECFW: ".e.cfw",
    EXIM: ".e.xim",
    FWC: ".fwc",
    HEX: ".hex",
    PACK: ".pack",
    PAR: ".par",
    PEM: ".pem",
    SET: ".set",
    TAR: ".tar",
    TPACK: ".tpack",
    ZIP: ".zip"
} as const;
